inlineVideo();

function inlineVideo() {
    const videoPlayButton = document.querySelectorAll('.js-play-video-btn');

    videoPlayButton.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();

            //const videoContent = document.querySelector('.js-inline-video-content');

            const videoSrc = btn.dataset.src;
            btn.parentNode.nextElementSibling.setAttribute('src', videoSrc);
            btn.parentNode.classList.add('is-hidden');

        });
    });
}
